import { ReactComponent as OurCityLogo } from "./web/our-city.svg";
import { ReactComponent as GdyniaAppLogo } from "./web/gdynia-app.svg";
import { ReactComponent as SignLanguage } from "./web/sign-language.svg";

export { OurCityLogo, GdyniaAppLogo, SignLanguage }
